// 261010 P9D vòng sửa 1 (#6, I10) — Provider opt-in của khung 8 bước: Bank / thế giới / composer nhúng ở bước 2 báo lỗi 409 `WORKFLOW_RUN_ACTIVE` bằng
// câu có sẵn + nút «Xem bước đang chạy». Không bọc Provider (UI cũ) ⇒ `useBankErrorReporter` = `message.error(apiErrorText(...))` như trước.
import React, { createContext, useCallback, useContext } from 'react';
import { Button, message } from 'antd';
import { apiErrorText } from './apiErrorText';
import { VIEW_RUNNING_LABEL, bankErrorDecision } from './bankRunActive';

const Ctx = createContext<{ onViewRunning: () => void } | null>(null);
export const WorkflowRunProvider: React.FC<{ onViewRunning: () => void; children: React.ReactNode }> = ({ onViewRunning, children }) => (
  <Ctx.Provider value={{ onViewRunning }}>{children}</Ctx.Provider>
);

/**
 * `fallback` = cách caller TỰ báo lỗi từ trước (giữ nguyên chữ / duration / kiểu); thiếu ⇒ `message.error(apiErrorText(err, what))`.
 * Reporter chỉ chen vào đúng một ca: có Provider + 409 `WORKFLOW_RUN_ACTIVE`.
 */
export function useBankErrorReporter(): (err: any, what: string, fallback?: (err: any) => void) => void {
  const ctx = useContext(Ctx);
  return useCallback((err: any, what: string, fallback?: (err: any) => void) => {
    const d = bankErrorDecision(!!ctx, err, what);
    if (d.mode === 'FALLBACK') { if (fallback) fallback(err); else message.error(apiErrorText(err, what)); return; }
    message.error({
      duration: 8,
      content: (
        <span>{d.text}{' '}
          <Button size="small" type="link" onClick={() => ctx!.onViewRunning()} data-testid="wf-view-running">{VIEW_RUNNING_LABEL}</Button>
        </span>),
    });
  }, [ctx]);
}
